import { render, staticRenderFns } from "./tzgg.vue?vue&type=template&id=56d23d30&scoped=true&"
import script from "./tzgg.vue?vue&type=script&lang=js&"
export * from "./tzgg.vue?vue&type=script&lang=js&"
import style0 from "./tzgg.vue?vue&type=style&index=0&id=56d23d30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d23d30",
  null
  
)

export default component.exports